import React, { useEffect, useState } from "react";
// Importar estilos específicos para Academia
import "./Academia.css";
import LofoFalcon from "../../Assets/Falcon FPV.webp";
import Navbar from "react-bootstrap/Navbar";

const Hero = ({ cookiesAccepted }) => {
   const [videoLoaded, setVideoLoaded] = useState(false);
   const [load, updateLoad] = useState(true);

   useEffect(() => {
      const timer = setTimeout(() => updateLoad(false), 1100);
      return () => clearTimeout(timer);
   }, []);

   const handleScroll = () => {
      const elemento = document.getElementById("start");
      if (elemento) {
         elemento.scrollIntoView({ behavior: "smooth" });
      }
   };

   return (
      <div className="hero-container">
         {/* Background Video */}
         {!videoLoaded && (
            <picture>
               {/* Versión para Móvil: Crea una copia de la imagen a 800px de ancho */}
               <source
                  media="(max-width: 768px)"
                  srcSet="/images/windsurf-mobile.webp"
               />
               {/* Versión Desktop y Fallback */}
               <img
                  src="/images/windsurf.webp"
                  alt="Grabación aérea y fotografía profesional con drones"
                  className="cover-loader"
                  fetchpriority="high"
                  loading="eager"
               />
            </picture>
         )}
         {cookiesAccepted && (
            <iframe
               src="https://player.vimeo.com/video/1125860243?background=1&autoplay=1&muted=1&loop=1&dnt=1"
               width="3840"
               height="2160"
               frameBorder="0"
               allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
               referrerPolicy="strict-origin-when-cross-origin"
               title="youtube-player"
               className="y-video"
               loading="lazy"
               onLoad={() => setVideoLoaded(true)}
            ></iframe>
         )}
         <Navbar fixed="top" expand="xl" className="academy-navbar">
            <img
               src={LofoFalcon}
               className="logo"
               alt="brand"
               title="Logo Falcon"
               style={{}}
               loading="eager"
            />
         </Navbar>

         {/* Main Content */}
         <main className="hero-content">
            <h1 className="title-top">COMO APRENDER A VOLAR DRONES FPV</h1>
            <h2 className="title-bottom">DESDE CERO </h2>

            <p className="description">
               Domina el FPV cinematográfico sin romper tu presupuesto. Aprende
               a volar, configurar y reparar tu drone con Joan Company <br />
               <span>
                  un piloto de drones profesional con mas de 8 años de
                  experiencia
               </span>
               .
            </p>
            <button className="btn-main" onClick={handleScroll}>
               EMPEZAR AHORA
            </button>
            {/* Footer / Scroll Hint */}
            <footer className="hero-footer">
               <p>DESLIZA PARA VOLAR</p>
               <div className="animate-bounce">
                  <svg
                     xmlns="http://www.w3.org/2000/svg"
                     width="32"
                     height="32"
                     viewBox="0 0 24 24"
                     fill="none"
                     stroke="currentColor"
                     stroke-width="2"
                     stroke-linecap="round"
                     stroke-linejoin="round"
                  >
                     <path d="m7 13 5 5 5-5"></path>
                     <path d="m7 6 5 5 5-5"></path>
                  </svg>
               </div>
            </footer>
         </main>
      </div>
   );
};

export default Hero;
